import { type SharedDocument, DocumentType } from 'types/Document';
import { getFileTypeFromExtension } from 'utils/file';
import AudioPreview from './AudioPreview';
import VideoPreview from './VideoPreview';
import ImagePreview from './ImagePreview';
import DocumentPreview from './DocumentPreview';

export type FilePreviewProps = {
  document: SharedDocument;
  useBlobForExtension?: boolean;
};

const FilePreview = ({ document, useBlobForExtension } : FilePreviewProps) : JSX.Element => {
  const fileName : string = useBlobForExtension ? document.blob.id : document.name;
  const documentType = getFileTypeFromExtension(fileName);

  if (documentType === DocumentType.MUSIC) {
    return <AudioPreview document={document} documentType={documentType} />;
  }

  if (documentType === DocumentType.VIDEO) {
    return <VideoPreview document={document} />;
  }

  if (document.type === DocumentType.PICTURE) {
    return <ImagePreview document={document} />;
  }

  return (
    <DocumentPreview
      document={document}
      documentType={documentType}
    />
  );
};

export default FilePreview;